import React, { useEffect, useState } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import api from "../../api";
import { notify } from "../../utils/toast";

/* ── Class Entry fixed categories ── */
const CLASS_CATS = [
  { key: "houseOfficer_coaster",    label: "House Officer",   vehicle: "Coaster" },
  { key: "houseOfficer_hiace",      label: "House Officer",   vehicle: "Hiace" },
  { key: "mbbs1_bus",               label: "MBBS 1st",        vehicle: "Bus" },
  { key: "mbbs1_coaster",           label: "MBBS 1st",        vehicle: "Coaster" },
  { key: "mbbs2_bus",               label: "MBBS 2nd",        vehicle: "Bus" },
  { key: "mbbs2_coaster",           label: "MBBS 2nd",        vehicle: "Coaster" },
  { key: "mbbs3_coaster",           label: "MBBS 3rd",        vehicle: "Coaster" },
  { key: "mbbs4_coaster",           label: "MBBS 4th",        vehicle: "Coaster" },
  { key: "mbbs5_bus",               label: "MBBS 5th",        vehicle: "Bus" },
  { key: "mbbs5_coaster",           label: "MBBS 5th",        vehicle: "Coaster" },
  { key: "consultant_acbus",        label: "Consultant",      vehicle: "AC Bus" },
  { key: "consultant_achiace",      label: "Consultant",      vehicle: "AC Hiace" },
  { key: "consultant_pharmd",       label: "Consultant",      vehicle: "PharmD Hiace" },
  { key: "consultant_dpt",          label: "Consultant",      vehicle: "DPT Hiace" },
  { key: "consultant_patho",        label: "Consultant",      vehicle: "Patho Coaster" },
  { key: "consultant_staff",        label: "Consultant",      vehicle: "Staff Non-AC Hiace" },
  { key: "sports_coaster",          label: "Sports",          vehicle: "Coaster" },
  { key: "pharmacy_bus",            label: "Pharmacy",        vehicle: "Bus" },
  { key: "bds_bus",                 label: "BDS",             vehicle: "Bus" },
  { key: "bds_hiace",               label: "BDS",             vehicle: "Hiace" },
  { key: "jmdc_visit",              label: "JMDC Visit",      vehicle: "" },
  { key: "car_duty",                label: "Car Duty",        vehicle: "" },
];

const VEHICLE_LIST = [
  { key: "habib_ja6560",   label: "Habib JA-6560 (Hino Bus)" },
  { key: "zubair_9940",    label: "Zubair 9940 (AC Bus)" },
  { key: "asim_jb0413",    label: "Asim JB-0413 (HINO Bus)" },
  { key: "yasir_ja8074",   label: "Yasir JA-8074 (HINO Bus)" },
  { key: "liaquat_ja5958", label: "Liaquat JA-5958 (Bedford Bus)" },
  { key: "farhan_jf3897",  label: "Farhan JF-3897 (Hiace)" },
  { key: "jf2120",         label: "JF-2120" },
  { key: "zaman_les8444",  label: "Zaman LES-8444 (AC Hiace)" },
  { key: "zaheer_shah",    label: "Zaheer Shah (AC Hiace)" },
  { key: "hanif_cv2704",   label: "Hanif CV-2704 (Hiroof)" },
  { key: "mali_je9036",    label: "M. Ali JE-9036 (Coaster)" },
  { key: "waheed_jf2418",  label: "Waheed JF-2418 (Coaster)" },
  { key: "waqas_je5991",   label: "Waqas JE-5991 (Coaster)" },
  { key: "arslan_je6221",  label: "Arslan JE-6221 (Coaster)" },
  { key: "naveed_coaster", label: "Naveed (Coaster)" },
  { key: "car_duty",       label: "Car Duty" },
  { key: "siddique_p0877", label: "Siddique P-0877" },
  { key: "tehseen",        label: "Tehseen" },
  { key: "sunny_224",      label: "Sunny 224" },
  { key: "bbt",            label: "BBT" },
];

const GROUPS = [
  "House Officers", "MBBS I", "MBBS II", "MBBS III", "MBBS IV", "MBBS V",
  "BDS", "Consultant Van", "D-Pharmacy", "Sports", "Other",
];

const VEHICLE_TYPES = ["Bus", "Coaster", "AC Bus", "AC Hiace", "Non-AC Hiace", "Hiace", "Hiroof", "Car", "Other"];

const thisMonth = moment().format("YYYY-MM");

/* ═══════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════ */
export const Entries = () => {
  const [activeTab, setActiveTab] = useState("class");
  const [hoveredTab, setHoveredTab] = useState("");

  const tabStyle = (t) => ({
    padding: "10px 24px",
    border: "none",
    background: activeTab === t ? "#002B5B" : hoveredTab === t ? "#dde3ea" : "#f1f5f9",
    color: activeTab === t ? "#fff" : hoveredTab === t ? "#002B5B" : "#374151",
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
    transition: "all 0.2s",
  });

  const tabProps = (t) => ({
    style: tabStyle(t),
    onClick: () => setActiveTab(t),
    onMouseEnter: () => setHoveredTab(t),
    onMouseLeave: () => setHoveredTab(""),
  });

  return (
    <div className="DashboardMain">
      <div style={{ display: "flex", gap: 10, marginBottom: 28, flexWrap: "wrap" }}>
        <button {...tabProps("class")}>Class Entry</button>
        <button {...tabProps("vehicle")}>Vehicle Entry</button>
        <button {...tabProps("daily")}>Daily Records</button>
      </div>

      {activeTab === "class"   && <ClassEntryTab />}
      {activeTab === "vehicle" && <VehicleEntryTab />}
      {activeTab === "daily"   && <DailyRecordTab />}
    </div>
  );
};

/* ── Shared pagination component ── */
const PAGE_SIZE = 10;

const Pagination = ({ page, total, onChange }) => {
  const totalPages = Math.ceil(total / PAGE_SIZE);
  if (totalPages <= 1) return null;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const btnStyle = (active) => ({
    padding: "5px 11px", borderRadius: 6, border: "1px solid #e2e8f0", cursor: "pointer",
    fontWeight: active ? 700 : 400, fontSize: 13,
    background: active ? "#002B5B" : "#fff", color: active ? "#fff" : "#374151",
  });
  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 16, flexWrap: "wrap" }}>
      <button style={btnStyle(false)} disabled={page === 1} onClick={() => onChange(page - 1)}>‹ Prev</button>
      {pages.map(p => <button key={p} style={btnStyle(p === page)} onClick={() => onChange(p)}>{p}</button>)}
      <button style={btnStyle(false)} disabled={page === totalPages} onClick={() => onChange(page + 1)}>Next ›</button>
      <span style={{ fontSize: 12, color: "#9ca3af", marginLeft: 4 }}>Page {page} of {totalPages}</span>
    </div>
  );
};

const ClearBtn = ({ onClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "6px 12px", borderRadius: 7, fontSize: 13, cursor: "pointer",
        border: hovered ? "1px solid #ef4444" : "1px solid #e2e8f0",
        background: hovered ? "#fee2e2" : "#f9fafb",
        color: hovered ? "#dc2626" : "#6b7280",
        transition: "all 0.15s",
      }}
    >
      Clear
    </button>
  );
};

/* ═══════════════════════════════════════════
   TAB 1 — CLASS ENTRY
═══════════════════════════════════════════ */
const ClassEntryTab = () => {
  const [month, setMonth]   = useState(thisMonth);
  const [records, setRecords] = useState([]);
  const [total, setTotal]   = useState(0);
  const [loader, setLoader] = useState(false);
  const [page, setPage]     = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem]   = useState(null);

  const getData = async (p = page) => {
    try {
      setLoader(true);
      const res = await api.getClassEntries({ month, page: p, limit: PAGE_SIZE });
      if (res?.success) { setRecords(res.records || []); setTotal(res.total || 0); }
    } catch { notify.error("Failed to load class entries"); }
    finally { setLoader(false); }
  };

  useEffect(() => { setPage(1); getData(1); }, [month]);
  useEffect(() => { if (page > 1) getData(page); }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;
    try {
      await api.deleteClassEntry(id);
      notify.success("Deleted");
      getData();
    } catch { notify.error("Failed to delete"); }
  };

  const openEdit = (item) => { setEditItem(item); setShowModal(true); };
  const openAdd  = () => { setEditItem(null); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditItem(null); };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <h3 style={{ margin: 0 }}>Class Entry ({records.length})</h3>
        <input type="month" value={month} onChange={e => setMonth(e.target.value)}
          style={{ padding: "6px 12px", borderRadius: 7, border: "1px solid #e2e8f0", fontSize: 14 }} />
      </div>

      {loader ? <div className="text-center py-5"><div className="spinner-border" /></div> : (
        <>
        <div className="TableMain">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Day</th>
                  {CLASS_CATS.map(c => (
                    <th key={c.key} style={{ whiteSpace: "nowrap", fontSize: 12 }}>
                      {c.label}{c.vehicle ? <><br /><span style={{ color: "#6b7280", fontWeight: 400 }}>{c.vehicle}</span></> : ""}
                    </th>
                  ))}
                  <th>Notes</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {records.length === 0 ? (
                  <tr><td colSpan={CLASS_CATS.length + 4} className="text-center py-4 text-muted">No records for this month</td></tr>
                ) : records.map((row) => (
                  <tr key={row._id}>
                    <td style={{ whiteSpace: "nowrap", fontWeight: 600 }}>{moment(row.date).format("DD MMM")}</td>
                    <td style={{ whiteSpace: "nowrap", fontSize: 13, color: "#6b7280" }}>{row.day}</td>
                    {CLASS_CATS.map(c => {
                      const val = row.data?.[c.key] ?? 0;
                      return (
                        <td key={c.key} style={{ textAlign: "center" }}>
                          <span style={{
                            display: "inline-block", minWidth: 24, padding: "2px 6px", borderRadius: 5, fontSize: 13,
                            background: val > 0 ? "#d1fae5" : "#f3f4f6",
                            color: val > 0 ? "#065f46" : "#9ca3af", fontWeight: val > 0 ? 700 : 400
                          }}>{val}</span>
                        </td>
                      );
                    })}
                    <td style={{ fontSize: 13, color: "#6b7280", maxWidth: 120 }}>{row.notes || "—"}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <div className="p-2 cursor-pointer" onClick={() => openEdit(row)}><i className="fa-solid fa-pen-to-square" /></div>
                        <div className="delete p-2 cursor-pointer" onClick={() => handleDelete(row._id)}><i className="fa-solid fa-trash" /></div>
                      </div>
                    </td>
                  </tr>
                ))}
                {records.length > 0 && (
                  <tr style={{ background: "#f0f4ff", borderTop: "2px solid #c7d2fe" }}>
                    <td colSpan={2} style={{ fontWeight: 700, fontSize: 13, color: "#002B5B", whiteSpace: "nowrap" }}>TOTAL</td>
                    {CLASS_CATS.map(c => {
                      const colTotal = records.reduce((sum, row) => sum + (row.data?.[c.key] ?? 0), 0);
                      return (
                        <td key={c.key} style={{ textAlign: "center" }}>
                          <span style={{
                            display: "inline-block", minWidth: 24, padding: "2px 6px", borderRadius: 5, fontSize: 13,
                            background: colTotal > 0 ? "#002B5B" : "#e5e7eb",
                            color: colTotal > 0 ? "#ffffff" : "#9ca3af", fontWeight: 700
                          }}>{colTotal}</span>
                        </td>
                      );
                    })}
                    <td colSpan={2}></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Pagination page={page} total={total} onChange={setPage} />
        </>
      )}

      <div className="AddEmpBtn" onClick={openAdd}><i className="fa-solid fa-plus" /></div>

      {showModal && (
        <ClassEntryModal item={editItem} handleClose={closeModal} getData={getData} defaultMonth={month} />
      )}
    </>
  );
};

const ClassEntryModal = ({ item, handleClose, getData, defaultMonth }) => {
  const [date, setDate]   = useState(item ? moment(item.date).format("YYYY-MM-DD") : "");
  const [notes, setNotes] = useState(item?.notes || "");
  const [counts, setCounts] = useState(() => {
    const init = {};
    CLASS_CATS.forEach(c => { init[c.key] = item?.data?.[c.key] ?? 0; });
    return init;
  });

  const handleSave = async () => {
    if (!date) { notify.error("Please select a date"); return; }
    try {
      const payload = { date, data: counts, notes };
      if (item) {
        await api.updateClassEntry(item._id, payload);
        notify.success("Updated");
      } else {
        await api.addClassEntry(payload);
        notify.success("Added");
      }
      getData();
      handleClose();
    } catch (e) { notify.error(e?.message || "Error"); }
  };

  return (
    <Modal show onHide={handleClose} size="lg">
      <div className="taskForm" style={{ maxWidth: "100%" }}>
        <div className="closeIcon" onClick={handleClose}><i className="fa-solid fa-xmark" /></div>
        <div className="h3">{item ? "Edit" : "Add"} Class Entry</div>

        <div className="form-group mb-3">
          <label>Date</label>
          <input type="date" className="form-control" value={date} onChange={e => setDate(e.target.value)} />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 12, marginBottom: 16 }}>
          {CLASS_CATS.map(c => (
            <div key={c.key} style={{ background: "#f8fafc", borderRadius: 8, padding: "10px 12px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                <strong>{c.label}</strong>{c.vehicle && ` — ${c.vehicle}`}
              </div>
              <input
                type="number" min={0}
                value={counts[c.key]}
                onChange={e => setCounts({ ...counts, [c.key]: Number(e.target.value) })}
                style={{ width: "100%", padding: "5px 8px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 14 }}
              />
            </div>
          ))}
        </div>

        <div className="form-group mb-3">
          <label>Notes</label>
          <input type="text" className="form-control" value={notes} onChange={e => setNotes(e.target.value)} placeholder="Optional notes" />
        </div>

        <button className="themeBtn w-100" onClick={handleSave}>{item ? "Update" : "Save"}</button>
      </div>
    </Modal>
  );
};

/* ═══════════════════════════════════════════
   TAB 2 — VEHICLE ENTRY
═══════════════════════════════════════════ */
const VehicleEntryTab = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate]     = useState("");
  const [records, setRecords]   = useState([]);
  const [total, setTotal]       = useState(0);
  const [loader, setLoader]     = useState(false);
  const [page, setPage]         = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem]   = useState(null);

  const getData = async (p = page) => {
    try {
      setLoader(true);
      const params = { page: p, limit: PAGE_SIZE };
      if (fromDate) params.fromDate = fromDate;
      if (toDate)   params.toDate   = toDate;
      const res = await api.getVehicleEntries(params);
      if (res?.success) { setRecords(res.records || []); setTotal(res.total || 0); }
    } catch { notify.error("Failed to load vehicle entries"); }
    finally { setLoader(false); }
  };

  useEffect(() => { setPage(1); getData(1); }, [fromDate, toDate]);
  useEffect(() => { if (page > 1) getData(page); }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;
    try { await api.deleteVehicleEntry(id); notify.success("Deleted"); getData(); }
    catch { notify.error("Failed to delete"); }
  };

  const openEdit = (item) => { setEditItem(item); setShowModal(true); };
  const openAdd  = () => { setEditItem(null); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditItem(null); };

  // flatten for table: one row per vehicle per date-record
  const flatRows = records.flatMap(rec =>
    (rec.vehicles || []).map((v, i) => ({ ...v, _recId: rec._id, _rec: rec, _vi: i }))
  );

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <h3 style={{ margin: 0 }}>Vehicle Entry ({total})</h3>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>From</span>
          <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)}
            style={{ padding: "6px 12px", borderRadius: 7, border: "1px solid #e2e8f0", fontSize: 14 }} />
          <span style={{ fontSize: 13, color: "#6b7280" }}>To</span>
          <input type="date" value={toDate} onChange={e => setToDate(e.target.value)}
            style={{ padding: "6px 12px", borderRadius: 7, border: "1px solid #e2e8f0", fontSize: 14 }} />
          {(fromDate || toDate) && (
            <ClearBtn onClick={() => { setFromDate(""); setToDate(""); }} />
          )}
        </div>
      </div>

      {loader ? <div className="text-center py-5"><div className="spinner-border" /></div> : (
        <>
        <div className="TableMain">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Day</th>
                  <th>Vehicle</th>
                  <th style={{ textAlign: "center" }}>Count</th>
                  <th>Notes</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {records.length === 0 ? (
                  <tr><td colSpan={6} className="text-center py-4 text-muted">No records found</td></tr>
                ) : records.map((rec) => {
                  const vlist = rec.vehicles || [];
                  return vlist.map((v, i) => (
                    <tr key={`${rec._id}-${i}`}>
                      {i === 0 && (
                        <>
                          <td rowSpan={vlist.length} style={{ whiteSpace: "nowrap", fontWeight: 600, verticalAlign: "middle" }}>
                            {moment(rec.date).format("DD MMM")}
                          </td>
                          <td rowSpan={vlist.length} style={{ whiteSpace: "nowrap", fontSize: 13, color: "#6b7280", verticalAlign: "middle" }}>
                            {rec.day}
                          </td>
                        </>
                      )}
                      <td style={{ fontSize: 14 }}>{v.vehicle}</td>
                      <td style={{ textAlign: "center" }}>
                        <span style={{
                          display: "inline-block", minWidth: 32, padding: "2px 8px", borderRadius: 5, fontSize: 13,
                          background: v.count > 0 ? "#d1fae5" : "#f3f4f6",
                          color: v.count > 0 ? "#065f46" : "#9ca3af", fontWeight: 700,
                        }}>{v.count ?? 0}</span>
                      </td>
                      {i === 0 && (
                        <>
                          <td rowSpan={vlist.length} style={{ fontSize: 13, color: "#6b7280", verticalAlign: "middle" }}>{rec.notes || "—"}</td>
                          <td rowSpan={vlist.length} style={{ verticalAlign: "middle" }}>
                            <div className="d-flex gap-2">
                              <div className="p-2 cursor-pointer" onClick={() => openEdit(rec)}><i className="fa-solid fa-pen-to-square" /></div>
                              <div className="delete p-2 cursor-pointer" onClick={() => handleDelete(rec._id)}><i className="fa-solid fa-trash" /></div>
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          </div>
        </div>
        <Pagination page={page} total={total} onChange={setPage} />
        </>
      )}

      <div className="AddEmpBtn" onClick={openAdd}><i className="fa-solid fa-plus" /></div>

      {showModal && (
        <VehicleEntryModal item={editItem} handleClose={closeModal} getData={getData} />
      )}
    </>
  );
};

const VehicleEntryModal = ({ item, handleClose, getData }) => {
  const [date, setDate]     = useState(item ? moment(item.date).format("YYYY-MM-DD") : "");
  const [notes, setNotes]   = useState(item?.notes || "");
  const [vehicles, setVehicles] = useState(
    item?.vehicles?.length ? item.vehicles.map(v => ({ vehicle: v.vehicle, count: v.count ?? 0 }))
                           : [{ vehicle: "", count: 0 }]
  );

  const addRow    = () => setVehicles([...vehicles, { vehicle: "", count: 0 }]);
  const removeRow = (i) => setVehicles(vehicles.filter((_, idx) => idx !== i));
  const updateRow = (i, field, val) => {
    const updated = [...vehicles];
    updated[i] = { ...updated[i], [field]: val };
    setVehicles(updated);
  };

  const handleSave = async () => {
    if (!date) { notify.error("Please select a date"); return; }
    const filled = vehicles.filter(v => v.vehicle.trim()).map(v => ({ vehicle: v.vehicle.trim(), count: v.count }));
    if (!filled.length) { notify.error("Add at least one vehicle"); return; }
    try {
      const payload = { date, vehicles: filled, notes };
      if (item) {
        await api.updateVehicleEntry(item._id, payload);
        notify.success("Updated");
      } else {
        await api.addVehicleEntry(payload);
        notify.success("Added");
      }
      getData();
      handleClose();
    } catch (e) { notify.error(e?.message || "Error"); }
  };

  return (
    <Modal show onHide={handleClose} size="lg">
      <div className="taskForm" style={{ maxWidth: "100%" }}>
        <div className="closeIcon" onClick={handleClose}><i className="fa-solid fa-xmark" /></div>
        <div className="h3">{item ? "Edit" : "Add"} Vehicle Entry</div>

        <div className="form-group mb-3">
          <label>Date</label>
          <input type="date" className="form-control" value={date} onChange={e => setDate(e.target.value)} />
        </div>

        <label style={{ fontWeight: 600, marginBottom: 8, display: "block" }}>Vehicles</label>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
          {vehicles.map((v, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                type="text"
                placeholder="e.g. Habib 6650 Hino Bus"
                value={v.vehicle}
                onChange={e => updateRow(i, "vehicle", e.target.value)}
                style={{ flex: 1, padding: "8px 12px", border: "1px solid #cbd5e1", borderRadius: 7, fontSize: 14 }}
              />
              <input
                type="number"
                min={0}
                value={v.count}
                onChange={e => updateRow(i, "count", Number(e.target.value))}
                style={{ width: 70, padding: "8px 10px", border: "1px solid #cbd5e1", borderRadius: 7,
                  fontSize: 14, fontWeight: 700, textAlign: "center" }}
              />
              {vehicles.length > 1 && (
                <div className="delete p-2 cursor-pointer" onClick={() => removeRow(i)}>
                  <i className="fa-solid fa-xmark" />
                </div>
              )}
            </div>
          ))}
          <button
            onClick={addRow}
            style={{ alignSelf: "flex-start", padding: "6px 14px", border: "1px dashed #94a3b8",
              background: "transparent", borderRadius: 7, fontSize: 13, color: "#64748b", cursor: "pointer" }}
          >
            + Add Vehicle
          </button>
        </div>

        <div className="form-group mb-3">
          <label>Notes</label>
          <input type="text" className="form-control" value={notes} onChange={e => setNotes(e.target.value)} placeholder="Optional notes" />
        </div>

        <button className="themeBtn w-100" onClick={handleSave}>{item ? "Update" : "Save"}</button>
      </div>
    </Modal>
  );
};

/* ═══════════════════════════════════════════
   TAB 3 — DAILY RECORDS
═══════════════════════════════════════════ */
const DailyRecordTab = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate]     = useState("");
  const [records, setRecords]   = useState([]);
  const [total, setTotal]       = useState(0);
  const [loader, setLoader]     = useState(false);
  const [page, setPage]         = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem]   = useState(null);

  const getData = async (p = page) => {
    try {
      setLoader(true);
      const params = { page: p, limit: PAGE_SIZE };
      if (fromDate) params.fromDate = fromDate;
      if (toDate)   params.toDate   = toDate;
      const res = await api.getDailyRecords(params);
      if (res?.success) { setRecords(res.records || []); setTotal(res.total || 0); }
    } catch { notify.error("Failed to load records"); }
    finally { setLoader(false); }
  };

  useEffect(() => { setPage(1); getData(1); }, [fromDate, toDate]);
  useEffect(() => { if (page > 1) getData(page); }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;
    try { await api.deleteDailyRecord(id); notify.success("Deleted"); getData(); }
    catch { notify.error("Failed to delete"); }
  };

  const openEdit = (item) => { setEditItem(item); setShowModal(true); };
  const openAdd  = () => { setEditItem(null); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditItem(null); };

  // Group by date, paginate over date groups
  const grouped = records.reduce((acc, r) => {
    const key = moment(r.date).format("YYYY-MM-DD");
    if (!acc[key]) acc[key] = [];
    acc[key].push(r);
    return acc;
  }, {});
  const dateKeys = Object.keys(grouped).sort().reverse();

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <h3 style={{ margin: 0 }}>Daily Records ({total})</h3>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>From</span>
          <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)}
            style={{ padding: "6px 12px", borderRadius: 7, border: "1px solid #e2e8f0", fontSize: 14 }} />
          <span style={{ fontSize: 13, color: "#6b7280" }}>To</span>
          <input type="date" value={toDate} onChange={e => setToDate(e.target.value)}
            style={{ padding: "6px 12px", borderRadius: 7, border: "1px solid #e2e8f0", fontSize: 14 }} />
          {(fromDate || toDate) && (
            <ClearBtn onClick={() => { setFromDate(""); setToDate(""); }} />
          )}
        </div>
      </div>

      {loader ? <div className="text-center py-5"><div className="spinner-border" /></div> : (
        records.length === 0 ? (
          <div className="text-center py-5 text-muted">No records for this date</div>
        ) : (
          <>{dateKeys.map(dateKey => (
            <div key={dateKey} style={{ marginBottom: 28 }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: "#002B5B", marginBottom: 10, padding: "6px 12px", background: "#eff6ff", borderRadius: 8, display: "inline-block" }}>
                {moment(dateKey).format("dddd, DD MMM YYYY")}
              </div>
              <div className="TableMain">
                <div className="table-responsive">
                  <table className="table table-hover drivers-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Group</th>
                        <th style={{ whiteSpace: "nowrap" }}>Vehicle Type</th>
                        <th style={{ whiteSpace: "nowrap" }}>Dep. Time</th>
                        <th style={{ whiteSpace: "nowrap" }}>Driver</th>
                        <th>Advance</th>
                        <th style={{ whiteSpace: "nowrap" }}>Petrol/Diesel</th>
                        <th>Destination</th>
                        <th style={{ whiteSpace: "nowrap" }}>Return Time</th>
                        <th style={{ whiteSpace: "nowrap" }}>Vehicle No.</th>
                        <th>Notes</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {grouped[dateKey].map((row, i) => (
                        <tr key={row._id}>
                          <td style={{ color: "#9ca3af", fontSize: 13 }}>{i + 1}</td>
                          <td><span style={{ background: "#ede9fe", color: "#6d28d9", padding: "2px 8px", borderRadius: 5, fontSize: 12, fontWeight: 600 }}>{row.group || "—"}</span></td>
                          <td style={{ fontSize: 13 }}>{row.vehicleType || "—"}</td>
                          <td style={{ fontSize: 13, whiteSpace: "nowrap" }}>{row.departureTime || "—"}</td>
                          <td style={{ fontSize: 13 }}>{row.driverName || "—"}</td>
                          <td style={{ fontSize: 13 }}>{row.advance || "—"}</td>
                          <td style={{ fontSize: 13 }}>{row.petrolDiesel || "—"}</td>
                          <td style={{ fontSize: 13 }}>{row.destination || "—"}</td>
                          <td style={{ fontSize: 13, whiteSpace: "nowrap" }}>{row.returnTime || "—"}</td>
                          <td style={{ fontSize: 13 }}>{row.vehicleNumber || "—"}</td>
                          <td style={{ fontSize: 13, color: "#6b7280" }}>{row.notes || "—"}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <div className="p-2 cursor-pointer" onClick={() => openEdit(row)}><i className="fa-solid fa-pen-to-square" /></div>
                              <div className="delete p-2 cursor-pointer" onClick={() => handleDelete(row._id)}><i className="fa-solid fa-trash" /></div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ))}<Pagination page={page} total={total} onChange={setPage} /></>
        )
      )}

      <div className="AddEmpBtn" onClick={openAdd}><i className="fa-solid fa-plus" /></div>

      {showModal && (
        <DailyRecordModal item={editItem} handleClose={closeModal} getData={getData} />
      )}
    </>
  );
};

const DailyRecordModal = ({ item, handleClose, getData }) => {
  const isKnownGroup = (v) => GROUPS.includes(v);
  const isKnownVType = (v) => VEHICLE_TYPES.includes(v);

  const [form, setForm] = useState({
    date:              item ? moment(item.date).format("YYYY-MM-DD") : "",
    group:             item?.group ? (isKnownGroup(item.group) ? item.group : "Other") : "",
    groupCustom:       item?.group && !isKnownGroup(item.group) ? item.group : "",
    vehicleType:       item?.vehicleType ? (isKnownVType(item.vehicleType) ? item.vehicleType : "Other") : "",
    vehicleTypeCustom: item?.vehicleType && !isKnownVType(item.vehicleType) ? item.vehicleType : "",
    departureTime:     item?.departureTime || "",
    driverName:        item?.driverName || "",
    advance:           item?.advance || "",
    petrolDiesel:      item?.petrolDiesel || "",
    destination:       item?.destination || "",
    returnTime:        item?.returnTime || "",
    vehicleNumber:     item?.vehicleNumber || "",
    notes:             item?.notes || "",
  });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async () => {
    if (!form.date) { notify.error("Please select a date"); return; }
    const payload = { ...form };
    if (payload.group === "Other") payload.group = payload.groupCustom.trim() || "Other";
    if (payload.vehicleType === "Other") payload.vehicleType = payload.vehicleTypeCustom.trim() || "Other";
    delete payload.groupCustom;
    delete payload.vehicleTypeCustom;
    try {
      if (item) {
        await api.updateDailyRecord(item._id, payload);
        notify.success("Updated");
      } else {
        await api.addDailyRecord(payload);
        notify.success("Added");
      }
      getData();
      handleClose();
    } catch (e) { notify.error(e?.message || "Error"); }
  };

  const fg = (label, name, type = "text", opts) => (
    <div className="col-md-6">
      <div className="form-group">
        <label>{label}</label>
        {type === "select" ? (
          <select name={name} className="form-control" value={form[name]} onChange={onChange}>
            <option value="">Select</option>
            {opts.map(o => <option key={o} value={o}>{o}</option>)}
          </select>
        ) : (
          <input type={type} name={name} className="form-control" value={form[name]} onChange={onChange} />
        )}
      </div>
    </div>
  );

  return (
    <Modal show onHide={handleClose} size="lg">
      <div className="taskForm" style={{ maxWidth: "100%" }}>
        <div className="closeIcon" onClick={handleClose}><i className="fa-solid fa-xmark" /></div>
        <div className="h3">{item ? "Edit" : "Add"} Daily Record</div>
        <div className="row">
          {fg("Date", "date", "date")}
          <div className="col-md-6">
            <div className="form-group">
              <label>Group / Class</label>
              <select name="group" className="form-control" value={form.group} onChange={onChange}>
                <option value="">Select</option>
                {GROUPS.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
              {form.group === "Other" && (
                <input type="text" name="groupCustom" className="form-control mt-2"
                  placeholder="Type group name..." value={form.groupCustom} onChange={onChange} autoFocus />
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Vehicle Type</label>
              <select name="vehicleType" className="form-control" value={form.vehicleType} onChange={onChange}>
                <option value="">Select</option>
                {VEHICLE_TYPES.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
              {form.vehicleType === "Other" && (
                <input type="text" name="vehicleTypeCustom" className="form-control mt-2"
                  placeholder="Type vehicle type..." value={form.vehicleTypeCustom} onChange={onChange} />
              )}
            </div>
          </div>
          {fg("Departure Time", "departureTime", "time")}
          {fg("Driver Name", "driverName")}
          {fg("Advance", "advance")}
          {fg("Petrol / Diesel", "petrolDiesel")}
          {fg("Destination", "destination")}
          {fg("Return Time", "returnTime", "time")}
          {fg("Vehicle Number", "vehicleNumber")}
          <div className="col-12">
            <div className="form-group">
              <label>Notes</label>
              <input type="text" name="notes" className="form-control" value={form.notes} onChange={onChange} placeholder="Optional" />
            </div>
          </div>
        </div>
        <div className="mt-3">
          <button className="themeBtn w-100" onClick={handleSave}>{item ? "Update" : "Save"}</button>
        </div>
      </div>
    </Modal>
  );
};
